const navigatorNameConf = {
  Ecard: (router) => {
    const props = router.params;
    const { isCash } = props;
    const b = isCash ? 'cashcoupons_list' : 'giftcard_list'; // 现金券 : 礼品卡
    return b;
  },
  FullPakage: (router) => {
    // const props = router.params;
    // const { typeId, couponId, extra_coupon_type_id, extra_coupon_id, activity_id } = props;
    // let b;
    // if (typeId || couponId || extra_coupon_type_id || extra_coupon_id) {
    //   b = 'coupon_gather';
    // } else if (activity_id) {
    //   b = 'active_gather';
    // } else {
    //   b = 'full_package';
    // }
    return 'makeup';
  },
  AddressLocation() {
    return 'map_location';
  },
  NewAddress() {
    return 'address_detail';
  },
  EditAddress() {
    return 'address_detail';
  },
  LightingExpress() {
    return 'flash_local';
  },
  AddressList() {
    return 'address';
  },
  Invoice: () => {
    return 'invoice_upsert';
  },
  Checkout: () => {
    return 'checkout';
  },
  InvoiceDetail: (router) => {
    const props = router.params;
    const { invoiceType } = props;
    return invoiceType === 'person' ? 'invoicetitle_add_personal' : 'invoicetitle_add_company';
  },
  OrderInvoiceExchange: (router) => {
    const props = router.params;
    const { strategy = 'exchange' } = props;
    return strategy === 'exchange' ? 'invoice_reissue' : 'invoice_upsert';
  },
  OrderInvoiceDetail: () => 'invoice',
  Cashier: () => 'cashier',
  PaySuccess: () => 'payment_succeed',
  Detail: () => {
    return 'product';
  },
  RecommendedMatch: (router) => {
    const props = router.params;
    const { pid } = props;
    return `makeup_${pid}`;
  },
  Store: () => {
    return 'store';
  },
  StoreAddress: () => {
    return 'address_search';
  },
  StoreNearbySearch: () => {
    return 'query_store';
  },
  StoreNearbySearchResult: () => {
    return 'wrapper_store';
  },
  Product3dShow: (router) => {
    const props = router.params;
    const { pid } = props;
    return `pano_product_${pid}`;
  },
  CustomizeElectronicCard: () => {
    return 'card_send';
  },
  reciveGiftCard: () => 'card_receive',
  SnapshotList: () => 'snapshot',
  SnapshotDetail: () => 'snapshot_detail',
};

const getDefaultNavigatorName = (comptName, router) => {
  if (navigatorNameConf[comptName]) {
    try {
      return navigatorNameConf[comptName](router);
    } catch (e) {}
  }
  return (comptName && `${comptName}`) || 'no_page';
};

const extraStatConstantsConf = {
  FullPakage: (router) => {
    const props = router.params;
    const { typeId, couponId, extra_coupon_type_id, extra_coupon_id, activity_id } = props;
    const extra = {};
    if (typeId || couponId || extra_coupon_type_id || extra_coupon_id) {
      extra.coupon_id = typeId || extra_coupon_type_id;
    } else if (activity_id) {
      extra.activity_id = activity_id;
    }
    return extra;
  },
  Checkout: (router) => {
    const props = router.params;
    const { isStoreFlash, isStorePickup } = props;
    const extra = { delivery_method: 1 };
    if (isStoreFlash || isStorePickup) {
      extra.delivery_method = isStoreFlash ? 2 : 3;
    }
    return extra;
  },
  Detail: () => {
    return {
      rn_enabled: true,
    };
  },
  Store: (router) => {
    const props = router.params;
    const { storeId, store_no } = props;
    return {
      org_id: storeId || store_no,
    };
  },
  StoreNearbySearch: (router) => {
    const props = router.params;
    const { storeId } = props;
    return {
      org_id: storeId || '',
    };
  },
  StoreNearbySearchResult: (router) => {
    const props = router.params;
    const { storeId } = props;
    return {
      org_id: storeId || '',
    };
  },
  OrderInvoiceExchange: (router) => {
    const props = router.params;
    const { orderId, orderStatus, invoiceStatus } = props;
    return {
      order_id: orderId || '',
      order_status: orderStatus || '',
      invoice_status: invoiceStatus || '',
    };
  },
  OrderInvoiceDetail: (router) => {
    const props = router.params;
    const { orderId, orderStatus } = props;
    return {
      order_id: orderId || '',
      order_status: orderStatus || '',
    };
  },
};
const getExtraStatConstants = (comptName, router) => {
  if (extraStatConstantsConf[comptName]) {
    try {
      return extraStatConstantsConf[comptName](router);
    } catch (e) {}
  }
  return {};
};
export { getDefaultNavigatorName, getExtraStatConstants };
